<template>
  <el-dialog
    :title="$t('updateStoreState.confirmOperation')"
    :visible.sync="dialogVisible"
    width="30%"
    @close="handleClose"
  >
    <div style="text-align: center;">
      <p>
        {{ $t('updateStoreState.confirmWhether') }}
        {{ updateStoreStateInfo.stateName }}!
      </p>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button @click="dialogVisible = false">
        {{ $t('updateStoreState.cancel') }}
      </el-button>
      <el-button type="primary" @click="_updateStoreState">
        {{ $t('updateStoreState.confirm') }}
      </el-button>
    </span>
  </el-dialog>
</template>

<script>
import { updateStoreState } from '@/api/admin/updateStoreState/updateStoreStateApi'

export default {
  name: 'UpdateStoreState',
  data() {
    return {
      dialogVisible: false,
      updateStoreStateInfo: {
        storeId: '',
        state: '',
        stateName: ''
      }
    }
  },
  methods: {
    open(params) {
      this.updateStoreStateInfo = { ...params }
      this.dialogVisible = true
    },
    handleClose() {
      this.updateStoreStateInfo = {
        storeId: '',
        state: '',
        stateName: ''
      }
    },
    async _updateStoreState() {
      try {
        const {code,msg} = await updateStoreState(this.updateStoreStateInfo)
        if(code != 0){
          this.$message.error(msg)
          return
        }
        this.$message.success(msg)
        this.dialogVisible = false
        this.$emit('refresh')
      } catch (error) {
        console.error(error)
      }
    }
  }
}
</script>